import React, { useEffect, useState } from "react";
import { useEval } from "../../hooks/fetch_api_hook/useEval";
import { useTheme } from "../../hooks/fetch_api_hook/useTheme";
import { useClasseContext } from "../../context/ClasseContext";
import Loading from "../general/Loading";
import AddSavoirModal from "./AddSavoirModal";
import { formatDate } from "../../utils/ClasseEvaluations";
import { url } from "../../utils/confserveur";
import { getSlidingYearRange } from "../../utils/sequencesfunction";
import useUpdateGroupe from "../../hooks/update_api_hook/useUpdateGroupe";


const EditEval = ({ ideval, onClose }) => {
const { updateGroupe , isLoading, error} = useUpdateGroupe();
const {classeNom, classesGroup} =  useClasseContext()
// Récuperation de l'API donnant la liste des themes - descripteurs - savoirfaires.
    const { data: ThemeDetail, isLoading: isLoadingTheme, isError : isErroRtheme } = useTheme(
      classeNom ? classeNom[0] : classesGroup.length > 0  && classesGroup[0][0] , 
      (classeNom==="" && classesGroup.length ===0) &&  "not-enabled"
    );

const {data : evaluation, isLoading : isLoadingResultatEval , isError} = useEval(ideval);
  const [title, setTitle] = useState("");
  const [date, setDate] = useState("");
  const [attendus, setAttendus] = useState([]);
  const [savoirs, setSavoirs] = useState([])
  const [dateRange, setDateRange] = useState({ min: '', max: '' });

  
  const [isModalOpen, setIsModalOpen] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  useEffect(() => {
     const loadRange = async () => {
       const { min, max } = await getSlidingYearRange();
       setDateRange({ min, max });
     };
     loadRange();
   }, []);
// Fonction générique pour ajouter un élément
const addItem = (type) => {
    setIsModalOpen(type); // Type = "attendus" ou "savoirs"
  };
  
  // Fonction générique pour supprimer un élément
  const removeItem = (type, id) => {
    if (type === "attendus") {
      setAttendus(attendus.filter((item) => item.id !== id));
    } else if (type === "savoirs") {
      setSavoirs(savoirs.filter((item) => item.id !== id));
    }
  };
  
 

  const handleAttenduChange = (newAttendu) => {
    setAttendus((prevAttendus) => {
      const exists = prevAttendus.some((attendu) => attendu.id === newAttendu.id);
  
      if (exists) {
        // Si l'attendu existe déjà, le supprimer
        return prevAttendus.filter((attendu) => attendu.id !== newAttendu.id);
      } else {
        // Sinon, ajouter le nouvel attendu
        return [
          ...prevAttendus,
          {
            id: newAttendu.id,
            description: newAttendu.description,
            competences: [], // Initialiser les compétences
          },
        ];
      }
    });
  };
  const handleSavoirChange = (newSavoir) => {
    setSavoirs((prevSavoirs) => {
      const exists = prevSavoirs.some((savoir) => savoir.id === newSavoir.id);
  
      if (exists) {
        // Si le savoir existe, on le retire
        return prevSavoirs.filter((savoir) => savoir.id !== newSavoir.id);
      } else {
        // Sinon, on l'ajoute
        return [
          ...prevSavoirs,
          {
            id: newSavoir.id,
            nom: newSavoir.nom,
            competences: [],
          },
        ];
      }
    });
  };
  
  // Fonction générique pour ajouter une compétence
  const addCompetence = (type, id, competenceName,index) => {

    if (type === "attendus") {
      setAttendus(
        attendus.map((item) =>
          item.id === id
            ? {
                ...item,
                competences: [
                  ...item.competences,
                  { id: index +1, nom: competenceName }, // Ajouter un objet compétence
                ],
              }
            : item
        )
      );
    } else if (type === "savoirs") {
      setSavoirs(
        savoirs.map((item) =>
          item.id === id
            ? {
                ...item,
                competences: [
                  ...item.competences,
                  { id: index +1, nom: competenceName }, // Ajouter un objet compétence
                ],
              }
            : item
        )
      );
    }
  };
  
  // Fonction générique pour supprimer une compétence
  const removeCompetence = (type, id, competenceName) => {
    if (type === "attendus") {
      setAttendus(
        attendus.map((item) =>
          item.id === id
            ? {
                ...item,
                competences: item.competences.filter(
                  (competence) => competence.nom !== competenceName // Supprimer par nom
                ),
              }
            : item
        )
      );
    } else if (type === "savoirs") {
      setSavoirs(
        savoirs.map((item) =>
          item.id === id
            ? {
                ...item,
                competences: item.competences.filter(
                  (competence) => competence.nom !== competenceName // Supprimer par nom
                ),
              }
            : item
        )
      );
    }
  };
  

const validateForm = () => {
  // Vérification des attendus et savoirs
  if (attendus.length === 0 && savoirs.length === 0) {
    setErrorMessage("Vous devez ajouter au moins un attendu ou un savoir.");
    return false;
  }

  if (attendus.some((attendu) => !attendu.competences || attendu.competences.length === 0)) {
    setErrorMessage("Tous les attendus doivent avoir au moins une compétence attribuée.");
    return false;
  }

  if (savoirs.some((savoir) => !savoir.competences || savoir.competences.length === 0)) {
    setErrorMessage("Tous les savoirs doivent avoir au moins une compétence attribuée.");
    return false;
  }

  // Vérification de la date
  if (date && dateRange.min && dateRange.max) {
    const inputDate = new Date(date);
    const minDate = new Date(dateRange.min);
    const maxDate = new Date(dateRange.max);

    if (inputDate < minDate || inputDate > maxDate) {
      setErrorMessage(`⚠️ La date doit être entre le ${new Date(dateRange.min).toLocaleDateString('fr-FR')} et le ${new Date(dateRange.max).toLocaleDateString('fr-FR')}`);
      return false; // ⚠️ IL MANQUAIT CE RETURN FALSE !
    }
  }

  setErrorMessage(""); // Aucune erreur
  return true;
};
  function buildExercicesJson(savoirs, attendus) {
    const exercices = [];

    // Traiter les savoirs
    if (savoirs && savoirs.length > 0) {
        for (const savoir of savoirs) {
            const compIds = savoir.competences.map(comp => comp.id); // Récupère les IDs des compétences
            exercices.push({
                titre: "Exercice savoir-faire", // Par défaut, ajustez si besoin
                comp_ids: compIds,
                savoir_faire_id: savoir.id
            });
        }
    }

    // Traiter les attendus
    if (attendus && attendus.length > 0) {
        for (const attendu of attendus) {
            const compIds = attendu.competences.map(comp => comp.id); // Récupère les IDs des compétences
            exercices.push({
                titre: "Exercice attendu", // Par défaut, ajustez si besoin
                comp_ids: compIds,
                attendu_id: attendu.id
            });
        }
    }

    return exercices;
}
  const handleSave = async() => {

    if(validateForm()){
    // Afficher une alerte de confirmation
        const userConfirmed = window.confirm(
            "⚠️ Attention !\n\n" +
            "La modification de cette évaluation supprimera tous les résultats déjà saisis.\n" +
            "Vous devrez ressaisir l'ensemble des résultats des élèves.\n\n" +
            "Êtes-vous sûr de vouloir continuer ?"
        );

        // Si l'utilisateur annule, on arrête la fonction
        if (!userConfirmed) {
            return;
        }

        // Si l'utilisateur confirme, on procède à la sauvegarde
        const payload = {
            titre: title,
            date: formatDate(date),
            nouveaux_exercices: buildExercicesJson(savoirs,attendus)
        };

        const urlupdate = `${url}evaluations/${ideval}/`;
        await updateGroupe(urlupdate, payload);

        onClose();
  };
  }
  
 useEffect( ()=> {

    if (attendus.length === 0 && savoirs.length === 0) {
        setErrorMessage("Vous devez ajouter au moins un attendu ou un savoir.");
        
      }
    
      else if (attendus.some((attendu) => !attendu.competences || attendu.competences.length === 0)) {
   
        setErrorMessage("Tous les attendus doivent avoir au moins une compétence attribuée.");
       
      }
    
      else if (savoirs.some((savoir) => !savoir.competences || savoir.competences.length === 0)) {
   
        setErrorMessage("Tous les savoirs doivent avoir au moins une compétence attribuée.");
        
      }
    
       else {setErrorMessage("");} // Aucune erreur
     
 },[attendus, savoirs])

  useEffect( () => {
    if(evaluation){
        setTitle(evaluation.titre)
        setDate(evaluation.date)
       
        if (evaluation.eleves_resultats?.length > 0) {
            // Combinez tous les résultats
            const allResults = evaluation.eleves_resultats.flatMap(
              (eleve) => eleve.resultats || []
            );
      
            // Récupérez les attendus
            const uniqueAttendus = new Map();
            allResults.forEach((result) => {
              if (result.attenduId) {
                if (!uniqueAttendus.has(result.attenduId)) {
                  uniqueAttendus.set(result.attenduId, {
                    id: result.attenduId,
                    description: result.attenduTitre,
                    competences: [{ id: result.competenceId, nom: result.competenceNom }],
                  });
                } else {
                  // Ajoutez les compétences si elles ne sont pas déjà présentes
                  const existingSavoir = uniqueAttendus.get(result.attenduId);
                  if (
                    !existingSavoir.competences.some(
                      (comp) => comp.id === result.competenceId
                    )
                  ) {
                    existingSavoir.competences.push({
                      id: result.competenceId,
                      nom: result.competenceNom,
                    });
                  }
                }
              }
            });
      
          
            // Récupérez les savoirs
            const uniqueSavoirs = new Map();
            allResults.forEach((result) => {
              if (result.savoirFaireId) {
                if (!uniqueSavoirs.has(result.savoirFaireId)) {
                  uniqueSavoirs.set(result.savoirFaireId, {
                    id: result.savoirFaireId,
                    nom: result.savoirTitre,
                    competences: [{ id: result.competenceId, nom: result.competenceNom }],
                  });
                } else {
                  // Ajoutez les compétences si elles ne sont pas déjà présentes
                  const existingSavoir = uniqueSavoirs.get(result.savoirFaireId);
                  if (
                    !existingSavoir.competences.some(
                      (comp) => comp.id === result.competenceId
                    )
                  ) {
                    existingSavoir.competences.push({
                      id: result.competenceId,
                      nom: result.competenceNom,
                    });
                  }
                }
              }
            });
        
            // Mettez à jour les états
            setAttendus(Array.from(uniqueAttendus.values()));
            setSavoirs(Array.from(uniqueSavoirs.values()));
          }
        }
      }, [evaluation]);
 
  if(isLoadingResultatEval){
    return <Loading loadingText={"Chargement de l'évaluation..."} /> 
  }



  if(evaluation && evaluation.eleves_resultats ){

  return (
   <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 backdrop-blur-md overflow-auto p-2 sm:p-4">
  <div className="max-w-7xl w-full mx-auto bg-white rounded-2xl sm:rounded-3xl shadow-2xl shadow-indigo-200 max-h-[95vh] overflow-auto relative border border-white/50">

    {/* Header immersif style ImportEleve */}
    <div className="relative overflow-hidden">
      {/* Glow effect */}
      <div className="absolute -inset-2 bg-gradient-to-r from-indigo-600 via-purple-500 to-violet-400 rounded-3xl blur-2xl opacity-30 animate-pulse" />

      <div className="relative overflow-hidden">
        {/* Background gradient */}
        <div className="absolute inset-0 bg-gradient-to-br from-indigo-600 via-purple-500 to-violet-400" />

        {/* Animated liquid blobs */}
        <svg className="absolute inset-0 w-full h-full" viewBox="0 0 800 200" preserveAspectRatio="none">
          <defs>
            <linearGradient id="edit-blob1" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#a78bfa" stopOpacity="0.5" />
              <stop offset="100%" stopColor="#c4b5fd" stopOpacity="0.2" />
            </linearGradient>
            <linearGradient id="edit-blob2" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#c4b5fd" stopOpacity="0.4" />
              <stop offset="100%" stopColor="#a78bfa" stopOpacity="0.1" />
            </linearGradient>
          </defs>

          <path fill="url(#edit-blob1)">
            <animate attributeName="d" dur="8s" repeatCount="indefinite"
              values="M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z;
                      M0,70 Q200,110 400,50 Q600,80 800,120 L800,200 L0,200 Z;
                      M0,100 Q200,40 400,80 Q600,130 800,70 L800,200 L0,200 Z" />
          </path>

          <path fill="url(#edit-blob2)">
            <animate attributeName="d" dur="6s" repeatCount="indefinite"
              values="M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z;
                      M0,90 Q300,130 500,80 Q700,100 800,140 L800,200 L0,200 Z;
                      M0,130 Q300,80 500,110 Q700,140 800,90 L800,200 L0,200 Z" />
          </path>

          {/* Floating particles */}
          <circle cx="150" cy="80" r="3" fill="white" opacity="0.4">
            <animate attributeName="cy" dur="3s" values="80;50;80" repeatCount="indefinite" />
          </circle>
          <circle cx="650" cy="100" r="2.5" fill="white" opacity="0.3">
            <animate attributeName="cy" dur="4s" values="100;60;100" repeatCount="indefinite" />
          </circle>
          <circle cx="400" cy="70" r="3" fill="white" opacity="0.35">
            <animate attributeName="cy" dur="3.5s" values="70;40;70" repeatCount="indefinite" />
          </circle>
          <circle cx="550" cy="90" r="2" fill="white" opacity="0.25">
            <animate attributeName="cy" dur="4.5s" values="90;55;90" repeatCount="indefinite" />
          </circle>
        </svg>

        {/* Content layer */}
        <div className="relative px-4 sm:px-6 md:px-8 py-6 sm:py-7 md:py-8">
          <div className="flex items-center justify-between">
            <button
              onClick={onClose}
              className="p-2 sm:p-2.5 bg-white/20 backdrop-blur rounded-xl border border-white/30 text-white hover:bg-white/30 transition-all duration-300"
            >
              <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
              </svg>
            </button>

            <div className="text-center flex-1">
              <div className="flex justify-center mb-2 sm:mb-3">
                <div className="p-2 sm:p-3 md:p-4 bg-white/20 backdrop-blur rounded-xl sm:rounded-2xl border border-white/30 shadow-xl">
                  <svg className="w-6 h-6 sm:w-8 sm:h-8 md:w-10 md:h-10 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M11 5H6a2 2 0 00-2 2v11a2 2 0 002 2h11a2 2 0 002-2v-5m-1.414-9.414a2 2 0 112.828 2.828L11.828 15H9v-2.828l8.586-8.586z" />
                  </svg>
                </div>
              </div>
              <h1 className="text-xl sm:text-2xl md:text-3xl font-bold text-white mb-1">
                Modifier l'Evaluation
              </h1>
              <p className="text-white/80 text-sm sm:text-base">
                Editez le titre, la date et les exercices
              </p>
            </div>

            <div className="w-10 sm:w-11" />
          </div>
        </div>
      </div>
    </div>

    {/* Contenu principal */}
    <div className="px-4 sm:px-6 md:px-8 lg:px-10 py-6 sm:py-8">

      {/* Alert Warning */}
      <div className="bg-red-50 border-2 border-red-200 rounded-xl sm:rounded-2xl p-3 sm:p-4 mb-6 flex items-start gap-2 sm:gap-3">
        <div className="p-1.5 sm:p-2 bg-red-500 rounded-lg flex-shrink-0">
          <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
            <circle cx="12" cy="12" r="10"/>
            <line x1="12" x2="12" y1="8" y2="12"/>
            <line x1="12" x2="12.01" y1="16" y2="16"/>
          </svg>
        </div>
        <div className="flex-1 min-w-0">
          <p className="text-red-800 font-semibold mb-0.5 sm:mb-1 text-sm sm:text-base">Attention</p>
          <p className="text-red-700 text-xs sm:text-sm md:text-base">
            Toute modification de l'evaluation entraînera la suppression des niveaux d'acquisition que vous avez prealablement saisis.
          </p>
        </div>
      </div>

      {/* Formulaire Titre & Date */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 sm:gap-6 mb-6 sm:mb-8">
        <div className="space-y-2">
          <label className="text-sm font-semibold text-gray-700 flex items-center gap-2">
            <div className="w-2 h-2 bg-indigo-500 rounded-full" />
            Titre de l'evaluation
          </label>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm sm:text-base focus:bg-white focus:border-indigo-500 focus:outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all duration-200"
            placeholder="Entrez le titre..."
          />
        </div>

        <div className="space-y-2">
          <label className="text-sm font-semibold text-gray-700 flex items-center gap-2">
            <div className="w-2 h-2 bg-indigo-500 rounded-full" />
            Date de l'evaluation
          </label>
          <input
            type="date"
            value={date}
            min={dateRange.min}
            max={dateRange.max}
            onChange={(e) => setDate(e.target.value)}
            className="w-full px-4 py-3 bg-slate-50 border-2 border-slate-200 rounded-xl text-sm sm:text-base focus:bg-white focus:border-indigo-500 focus:outline-none focus:ring-4 focus:ring-indigo-500/10 transition-all duration-200"
          />
        </div>
      </div>

      {/* Bouton Ajouter */}
      <div className="flex justify-center mb-6 sm:mb-8">
        <div className="relative group">
          <div className="absolute -inset-0.5 bg-gradient-to-r from-indigo-400 via-purple-500 to-indigo-400 rounded-xl opacity-75 blur group-hover:opacity-100 transition duration-300 animate-pulse" />
          <button
            onClick={() => addItem("savoirs")}
            className="relative flex items-center gap-2 sm:gap-3 px-5 sm:px-6 py-2.5 sm:py-3 bg-gradient-to-r from-indigo-500 to-purple-600 hover:from-indigo-600 hover:to-purple-700 text-white font-semibold rounded-xl shadow-lg transition-all duration-300 text-sm sm:text-base"
          >
            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
            </svg>
            Ajouter un attendu
          </button>
        </div>
      </div>

      {/* Separator */}
      <div className="flex items-center gap-3 sm:gap-4 mb-6 sm:mb-8">
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" />
        <span className="text-slate-400 text-xs sm:text-sm font-medium">Exercices</span>
        <div className="flex-1 h-px bg-gradient-to-r from-transparent via-slate-300 to-transparent" />
      </div>

      {/* Sections Attendus et Savoirs */}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8 mb-6 sm:mb-8">

        {/* Section Attendus */}
        <div className="space-y-4">
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="p-1.5 sm:p-2 bg-gradient-to-br from-blue-500 to-cyan-500 rounded-lg sm:rounded-xl flex-shrink-0">
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
              </svg>
            </div>
            <div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800">Les attendus du niveau</h3>
              <p className="text-xs sm:text-sm text-slate-500">{attendus.length} attendu(s)</p>
            </div>
          </div>

          {attendus.length === 0 && (
            <div className="border-2 border-dashed border-slate-200 rounded-xl p-6 sm:p-8 text-center">
              <p className="text-slate-400 text-sm">Aucun attendu pour le moment</p>
            </div>
          )}

          {attendus.map((attendu, index) => (
            <div
              key={attendu.id}
              className="group bg-white rounded-xl border-2 border-blue-100 hover:border-blue-300 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              {/* Barre de couleur en haut */}
              <div className="h-1 bg-gradient-to-r from-blue-500 to-cyan-500" />

              <div className="p-4 sm:p-5">
                <div className="flex items-start justify-between mb-3 sm:mb-4">
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2.5 py-0.5 bg-blue-100 text-blue-700 text-[10px] sm:text-xs font-semibold rounded-full mb-2">
                      Attendu #{index + 1}
                    </span>
                    <p className="text-sm sm:text-base text-gray-800 font-medium truncate" title={attendu.description}>
                      {attendu.description}
                    </p>
                  </div>
                  <button
                    onClick={() => removeItem("attendus", attendu.id)}
                    className="ml-2 sm:ml-3 p-1.5 sm:p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200"
                    title="Supprimer cet attendu"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>

                <div className="bg-slate-50 rounded-lg p-3">
                  <p className="font-semibold text-gray-600 text-xs mb-2 sm:mb-3 uppercase tracking-wider">Competences</p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
                    {["Calculer", "Chercher", "Communiquer", "Raisonner", "Modéliser", "representer"].map((competence, idx) => {
                      const checked = attendu.competences.some((c) => c.nom === competence);
                      return (
                        <label
                          key={idx}
                          className={`flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg cursor-pointer transition-all duration-200 text-xs sm:text-sm ${
                            checked ? 'bg-blue-100 text-blue-800 border border-blue-300' : 'bg-white border border-slate-200 text-gray-600 hover:border-blue-200'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => {
                              if (e.target.checked) {
                                addCompetence("attendus", attendu.id, competence, idx);
                              } else {
                                removeCompetence("attendus", attendu.id, competence);
                              }
                            }}
                            className="w-3.5 h-3.5 text-blue-600 rounded border-gray-300 focus:ring-blue-500"
                          />
                          {competence}
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Section Savoirs */}
        <div className="space-y-4">
          <div className="flex items-center gap-2 sm:gap-3 mb-3 sm:mb-4">
            <div className="p-1.5 sm:p-2 bg-gradient-to-br from-purple-500 to-pink-500 rounded-lg sm:rounded-xl flex-shrink-0">
              <svg className="w-4 h-4 sm:w-5 sm:h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
                <path strokeLinecap="round" strokeLinejoin="round" d="M12 6.253v13m0-13C10.832 5.477 9.246 5 7.5 5S4.168 5.477 3 6.253v13C4.168 18.477 5.754 18 7.5 18s3.332.477 4.5 1.253m0-13C13.168 5.477 14.754 5 16.5 5c1.747 0 3.332.477 4.5 1.253v13C19.832 18.477 18.247 18 16.5 18c-1.746 0-3.332.477-4.5 1.253" />
              </svg>
            </div>
            <div>
              <h3 className="text-base sm:text-lg md:text-xl font-bold text-gray-800">Attendus de fin de cycle - Eduscol</h3>
              <p className="text-xs sm:text-sm text-slate-500">{savoirs.length} savoir(s)</p>
            </div>
          </div>

          {savoirs.length === 0 && (
            <div className="border-2 border-dashed border-slate-200 rounded-xl p-6 sm:p-8 text-center">
              <p className="text-slate-400 text-sm">Aucun savoir pour le moment</p>
            </div>
          )}

          {savoirs.map((savoir, index) => (
            <div
              key={savoir.id}
              className="group bg-white rounded-xl border-2 border-purple-100 hover:border-purple-300 shadow-sm hover:shadow-lg transition-all duration-300 overflow-hidden"
            >
              {/* Barre de couleur en haut */}
              <div className="h-1 bg-gradient-to-r from-purple-500 to-pink-500" />

              <div className="p-4 sm:p-5">
                <div className="flex items-start justify-between mb-3 sm:mb-4">
                  <div className="flex-1 min-w-0">
                    <span className="inline-block px-2.5 py-0.5 bg-purple-100 text-purple-700 text-[10px] sm:text-xs font-semibold rounded-full mb-2">
                      Savoir #{index + 1}
                    </span>
                    <p className="text-sm sm:text-base text-gray-800 font-medium truncate" title={savoir.nom}>
                      {savoir.nom}
                    </p>
                  </div>
                  <button
                    onClick={() => removeItem("savoirs", savoir.id)}
                    className="ml-2 sm:ml-3 p-1.5 sm:p-2 text-slate-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-all duration-200"
                    title="Supprimer ce savoir"
                  >
                    <svg className="w-4 h-4 sm:w-5 sm:h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
                    </svg>
                  </button>
                </div>

                <div className="bg-slate-50 rounded-lg p-3">
                  <p className="font-semibold text-gray-600 text-xs mb-2 sm:mb-3 uppercase tracking-wider">Competences</p>
                  <div className="grid grid-cols-2 sm:grid-cols-3 gap-1.5 sm:gap-2">
                    {["Calculer", "Chercher", "Communiquer", "Raisonner", "Modéliser", "representer"].map((competence, idx) => {
                      const checked = savoir.competences.some((c) => c.nom === competence);
                      return (
                        <label
                          key={idx}
                          className={`flex items-center gap-1.5 sm:gap-2 px-2 sm:px-3 py-1.5 sm:py-2 rounded-lg cursor-pointer transition-all duration-200 text-xs sm:text-sm ${
                            checked ? 'bg-purple-100 text-purple-800 border border-purple-300' : 'bg-white border border-slate-200 text-gray-600 hover:border-purple-200'
                          }`}
                        >
                          <input
                            type="checkbox"
                            checked={checked}
                            onChange={(e) => {
                              if (e.target.checked) {
                                addCompetence("savoirs", savoir.id, competence, idx);
                              } else {
                                removeCompetence("savoirs", savoir.id, competence);
                              }
                            }}
                            className="w-3.5 h-3.5 text-purple-600 rounded border-gray-300 focus:ring-purple-500"
                          />
                          {competence}
                        </label>
                      );
                    })}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Section Actions */}
      {errorMessage && (
        <div className="mb-4 sm:mb-6 bg-amber-50 border-2 border-amber-200 rounded-xl sm:rounded-2xl p-3 sm:p-4 flex items-start gap-2 sm:gap-3">
          <div className="p-1.5 sm:p-2 bg-amber-500 rounded-lg flex-shrink-0">
            <svg className="w-4 h-4 sm:w-5 sm:h-5" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" x2="12" y1="8" y2="12"/>
              <line x1="12" x2="12.01" y1="16" y2="16"/>
            </svg>
          </div>
          <p className="text-sm sm:text-base font-semibold text-amber-800">{errorMessage}</p>
        </div>
      )}

      <div className="relative group">
        {!errorMessage && (
          <div className="absolute -inset-0.5 bg-gradient-to-r from-emerald-400 via-green-500 to-emerald-400 rounded-xl opacity-75 blur group-hover:opacity-100 transition duration-300 animate-pulse" />
        )}
        <button
          onClick={handleSave}
          disabled={!!errorMessage}
          className={`relative w-full flex items-center justify-center gap-2 sm:gap-3 px-6 py-3 sm:py-4 rounded-xl font-bold text-base sm:text-lg transition-all duration-300 ${
            errorMessage
              ? "bg-gray-200 text-gray-400 cursor-not-allowed"
              : "bg-gradient-to-r from-emerald-500 to-green-600 hover:from-emerald-600 hover:to-green-700 text-white shadow-lg shadow-emerald-500/30 hover:shadow-xl hover:shadow-emerald-500/50"
          }`}
        >
          <svg className="w-5 h-5 sm:w-6 sm:h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" strokeWidth="2">
            <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
          </svg>
          Sauvegarder les modifications
        </button>
      </div>
    </div>
  </div>

  {/* Modal */}
  {isModalOpen && (
    <AddSavoirModal
      show={!!isModalOpen}
      onClose={() => setIsModalOpen(false)}
      onSave={(newItem) => {
        if (isModalOpen === "attendus") {
          setAttendus((prev) => [...prev, newItem]);
        } else if (isModalOpen === "savoirs") {
          setSavoirs((prev) => [...prev, newItem]);
        }
        setIsModalOpen(false);
      }}
      themes={ThemeDetail ? ThemeDetail : []}
      selectedAttendus={attendus}
      selectedSavoirs={savoirs}
      handleAttenduChange={handleAttenduChange}
      handleSavoirChange={handleSavoirChange}
    />
  )}
</div>
  );
}
};

export default EditEval;